import Layout from "../components/Layout/Layout"
import OrdersLayout from "../components/OrdersLayout/OrdersLayout"
import HistoryLayoutLoader from "../components/LayoutLoaders/HistoryLayoutLoader"

export default function History() {
  return (
    <Layout mainLoader={<HistoryLayoutLoader />} isHeaderMobHidden>
      <OrdersLayout layout={"history"} />
    </Layout>
  )
}
